
  import { KanziEnvironmentModel, CUSTOMERTYPES } from '@kanzi-apes/kanzi-models';
  export const environment: KanziEnvironmentModel = {
    production: false,
    kongTenantApi: '',
    kongApi: 'https://api-apes-stock-rfid-staging.technoapes.io/',
    wmsKongApi: '',
    helpdeskUrl: '',
    kongTrackingFile: 'https://api-apes-stock-rfid-staging.technoapes.io/logistics/tracking-files/',
    apesPdfCreatorApi: '',
    qsApiUrl: '',
    qsApiUrlCommon: 'https://apes-qs-embed-api.technoapes.io/',
    bucket_image_storage: '',
    nodeRedApi: '',
    socketIOServer: '',
    noderedCustomer: '',
    flightReportApiUrl: '',
    tokenFlightReport: '',
    gmtZone: '',
    isQuantity: false,
    tenantId: '8f50a209',
    filterByLocation: true,
    useEanAsId: false,
    formats: {
      date: 'MM/DD/YYYY',
    },
    apiModules: {
      auth: 'auth/',
      authToken: 'token/login/',
      config: 'core_config/',
      inventory: 'inventory/',
      operations: 'operations/',
      rfid: 'rfid/',
      audits: 'inventory/audits/',
      logistics: 'logistics/',
      customers: 'customers/',
      integrations: 'integrations/',
      maintenance: 'maintenance/',
      stock: '',
      invoicing: 'invoicing/',
    },
    configUI: { mainMenuStyle: 'static', scale: 12 },
    assets: {
      logo: 'apes_logo.png',
      background: '',
      root:  'assets/',
      rootClient: '',
      paths: {
        css: 'css/',
        logos: 'images/logos/',
        backgrounds: 'images/backgrounds/',
        js: 'js/',
      },
    },
    modules: {
      customerType: 'STOCK_OLDER',
      automaticPrinting: false,
      dashboards: false,
      isEnableButtonExternalId: false,
      editContacts: false,
      discountsContacts: false,
      disabledCreateContacts: false,
      isFilterWerehouse: false,      
      contacts: true,
      contactsParams: true,
      products: {
        parent: true,
        products: true,
        assets: false,
        maintenanceTrace: false,
        filterTypeSku: false,
        setProperties: false,
        enableItemActivation: false,
        isDisabledCreateProduct: false,
        deleteProduct: false,
        editProducts: false,
        propsRequired:false,
        aditionalParamsInactiveTags: false,
        inactiveTagsAccions: false,
        activeComments: false,
        clientEan13: false,
        loadProductGroups: true,
        loadMasterFile: true,
        setImagesProduct: false,
      },
      inventories: {
        parent: true,
        products: true,
        assets: false,
        booking: false,
        bookingCreate: false,
        bookingList: false,
        hideColumnsSummary: false,
      },
      moves: {
        parent: true,
        dashboards: false,
        moves: true,
        sales: false,
        price: false,
      },
      nodes: {
        nodeTypes: [],
      },
      production: {
        parent: true,
        productionOrder: false,
        productionLocationType: 'WAREHOUSE',
        purchaseOrder: false,
        purchaseLocationType: 'WAREHOUSE',
        printOrder: false,
        filterOrder: false,
        external_id: false,
        by_ean: false,
        productionOrderIdHide: false,
        hideTagTemplate: false,
        enabledInventoryProps: false,
        productionOrderProperties: false,
        purchaseOrderProperties: false,
        loadMasterFile: false,
      },
      purchaseOrders:{
        parent: true,
        loadMasterFile: false,
      },
      printOrders:{
        generatePrintFile: false,
        printAgent: false,
        printAgentUrl: '',
        printAgentSocketUrl: '',
        defaultPrinterIp: '',
      },
      operations: {
        parent: false,
        storeOrder: false,
        storeOrderTypes: false,
        distributionOrder: false,
        workOrder: { 
          parent: true, 
          reasignCreateNewOrder: false, 
          loadPackingsFile: false
        },
        packings: false,
        dispatchPacks: true,
        budgets: false,
        booking: false,
        woAssignsLeader:false
      },
      storeOrders: {
        parent: true,
        loadMasterFile: false,
      },
      audits: {
        parent: false,
        calendar: false,
        products: false,
        assets: false,
        typeAuditProps: 'DEFAULT',
        summaryDetail: false,
        lossControlOption: false,
        auditByProducts: false,
      },
      logisticPacking: {
        parent: false,
        list: false,
        listStates: false,
        create: false,
        initialStateForValidation: 'FILLED',
        bulkCreatePackings: false,
        bulkPrintAgent: false,
        printAgentSocketUrl: 'http://localhost:5000',
        },
      logistics: {
        parent: false,
        shippingOrders: false,
        trackOrderCreate: false,
        trackings: false,
        printers: false,
        pickingFile: false,
      },
      alerts: false,
    },
  }